import type { OrderOverviewRow } from '../../types/dashboard';

/**
 * Чисті обчислення для кола «Виконання замовлень».
 *
 * Живуть окремо від компонента, щоб їх можна було перевірити тестом без
 * рендера: у віджеті вони визначають, яке число стоїть у центрі кола.
 */

/**
 * Середнє виконання по замовленнях — та сама семантика, що на бекенді:
 * кожне замовлення важить однаково. Сумувати «виготовлено/потрібно» не можна,
 * бо одиниці різні (штуки меблів і м² підлоги в одну суму не складаються).
 *
 * Порожній набір — 0 %: ділити немає на що.
 */
export function averageProgress(orders: OrderOverviewRow[]): number {
  if (orders.length === 0) return 0;
  const sum = orders.reduce((acc, o) => acc + o.progress_pct, 0);
  return Math.round(sum / orders.length);
}

/**
 * Порядок списку: найближчий дедлайн зверху, замовлення без дедлайну — в
 * кінці (вони нічого не підпирають). Вхідний масив не змінюється.
 */
export function sortByDeadline(orders: OrderOverviewRow[]): OrderOverviewRow[] {
  return [...orders].sort((a, b) => {
    if (!a.deadline && !b.deadline) return 0;
    if (!a.deadline) return 1;
    if (!b.deadline) return -1;
    return a.deadline < b.deadline ? -1 : a.deadline > b.deadline ? 1 : 0;
  });
}

/** Замовлення одного статусу в тому самому порядку. */
export function ordersInStatus(orders: OrderOverviewRow[], status: string): OrderOverviewRow[] {
  return sortByDeadline(orders.filter((o) => o.status === status));
}
